import { render, staticRenderFns } from "./BannerProductCategory.vue?vue&type=template&id=7d6cadee&scoped=true&"
import script from "./BannerProductCategory.vue?vue&type=script&lang=js&"
export * from "./BannerProductCategory.vue?vue&type=script&lang=js&"
import style0 from "./BannerProductCategory.vue?vue&type=style&index=0&id=7d6cadee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6cadee",
  null
  
)

export default component.exports